import { useMap } from "react-leaflet";

export const SetView=({ center })=>{
    const map = useMap();
    map.setView(center);
    return null;
}